const layoutState = {
  fullscreen: false,
  isPreview: false,
  activePanels: [],
  isNextFlyerBannerCSBOpen: false,
  isNextFlyerBannerCSBVOpen: false,
}

export default layoutState
